import React from 'react';
import moment from 'moment';
import { Tabs, TabPanel, TabCommon, DatePicker, PageBar } from '@tencent/spaui';
import { RPCFactory } from './../../../utils/RequestUtil';
import { NoticeTable } from './noticeTable';

export class NoticeNav extends React.PureComponent {
  constructor(props) {
    super(props);
    const startDate = moment(Date.now() - 365 * 24 * 3600 * 1000).format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');
    this.state = {
      categoryId: undefined,
      allCategoryData: {},
      unReadCategoryData: props.unReadData,
      startDate,
      endDate,
      pageIndex: 1,
      pageSize: 10,
      noticeTotalCount: 0,
    };
  }

  componentDidMount() {
    // 拿ALL来确定category的所有种类和名称
    RPCFactory.noticeCenter.getCategory({ noticeStatus: this.props.noticeStatus }).done((data) => {
      this.flattenCategory(data);
      this.setState({ allCategoryData: data, noticeTotalCount: data.noticeCount });
    });
    if (this.state.unReadCategoryData.children) {
      const unReadCategoryData = { ...this.state.unReadCategoryData };
      this.flattenCategory(unReadCategoryData);
      this.setState({ unReadCategoryData });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.categoryId !== prevState.categoryId ||
      this.state.startDate !== prevState.startDate ||
      this.state.endDate !== prevState.endDate ||
      this.props.noticeStatus !== prevProps.noticeStatus
    ) {
      this.props.getUnread();
    }
    if (prevProps.unReadData !== this.props.unReadData) {
      const unReadCategoryData = { ...this.props.unReadData };
      this.flattenCategory(unReadCategoryData);
      this.setState({ unReadCategoryData });
    }
  }

  handleChange = (event, categoryId) => {
    this.setState({
      categoryId: categoryId == '' ? undefined : categoryId,
    });
  };

  handleDateChange = (event, startDate, endDate) => {
    this.setState({
      startDate,
      endDate,
    });
  };

  handlePageIndexChange = (event, pageIndex) => {
    // 切换页码
    this.setState({
      pageIndex,
    });
  };

  updateNoticeCount = (count) => {
    this.setState({ noticeTotalCount: count });
  };

  handlePageSizeChange = (pageIndex, pageSize) => {
    // 切换每页数量
    this.setState({
      pageIndex,
      pageSize,
    });
  };

  flattenCategory = (data) => {
    const allCategory = {
      categoryId: data.categoryId,
      categoryLevel: data.categoryLevel,
      categoryName: data.categoryName,
      noticeCount: data.noticeCount,
    };
    return data.children.unshift(allCategory);
  };

  goBack = () => {
    history.back();
  };

  render() {
    const {
      categoryId,
      allCategoryData,
      unReadCategoryData,
      startDate,
      endDate,
      pageIndex,
      pageSize,
      noticeTotalCount,
    } = this.state;
    return (
      <Tabs onChange={this.handleChange} value={categoryId} needSlider={false}>
        {allCategoryData.children &&
          allCategoryData.children.map((tab) => {
            let tabContent = tab.categoryName;
            if (unReadCategoryData.children) {
              const { noticeCount } = unReadCategoryData.children.find((ele) => ele.categoryId == tab.categoryId);
              tabContent = `${tab.categoryName}(${noticeCount})`;
            }
            return <TabPanel tab={tabContent} name={tab.categoryId}></TabPanel>;
          })}
        <TabCommon>
          <div className="toolbar-has-datepicker">
            <div className="toolbar-right">
              <div className="toolbar-right-inner">
                <DatePicker
                  input
                  hideSubmitButton
                  horizontalPosition="left"
                  type="range"
                  startDate={startDate}
                  endDate={endDate}
                  onChange={this.handleDateChange}
                />
              </div>
            </div>
          </div>
          <NoticeTable
            noticeStatus={this.props.noticeStatus}
            categoryId={categoryId}
            startDate={startDate}
            endDate={endDate}
            pageIndex={pageIndex}
            pageSize={pageSize}
            updateNoticeCount={this.updateNoticeCount}
          />
          <PageBar
            value={pageIndex}
            pageSize={pageSize}
            totalSize={noticeTotalCount}
            pageSizeList={[10, 20, 50]}
            onChange={this.handlePageIndexChange}
            onPageSizeChange={this.handlePageSizeChange}
          />
        </TabCommon>
      </Tabs>
    );
  }
}
